import { Badge } from "@/components/ui/badge";

type CodeStatus = "active" | "redeemed" | "expired_unredeemed" | "voided";
type GrantStatus = "active" | "expired" | "revoked";

const CODE_LABELS: Record<CodeStatus, string> = {
  active: "Activo",
  redeemed: "Canjeado",
  expired_unredeemed: "Expirado",
  voided: "Anulado",
};

const CODE_VARIANTS: Record<CodeStatus, "blue" | "green" | "gray" | "red"> = {
  active: "blue",
  redeemed: "green",
  expired_unredeemed: "gray",
  voided: "red",
};

const GRANT_LABELS: Record<GrantStatus, string> = {
  active: "Activo",
  expired: "Expirado",
  revoked: "Revocado",
};

const GRANT_VARIANTS: Record<GrantStatus, "green" | "gray" | "red"> = {
  active: "green",
  expired: "gray",
  revoked: "red",
};

export function CodeStatusBadge({ status }: { status: string }) {
  const s = (CODE_LABELS[status as CodeStatus] ? status : "active") as CodeStatus;
  return <Badge variant={CODE_VARIANTS[s]}>{CODE_LABELS[s]}</Badge>;
}

export function GrantStatusBadge({ status }: { status: string }) {
  const s = (GRANT_LABELS[status as GrantStatus] ? status : "active") as GrantStatus;
  return <Badge variant={GRANT_VARIANTS[s]}>{GRANT_LABELS[s]}</Badge>;
}
